var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductTreatment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#1D1D1B",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.656 1.983.102 1.43c.021.458.091.911.208 1.35l.187.705H8.848l.186-.705a6.45 6.45 0 0 0 .208-1.35l.102-1.43a.655.655 0 1 1 1.312 0zM11.857 5.52l-.372-.052h-2.97l-.372.053v2.324h3.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.032 9.827 8.46 9.6a1.02 1.02 0 0 0 .542-.9v-.856H11V8.7c0 .378.208.724.541.9l.428.227a2.88 2.88 0 0 1 1.534 2.547v6.867c0 .79-.64 1.432-1.432 1.432H7.93c-.791 0-1.432-.641-1.432-1.432v-6.867c0-1.068.59-2.048 1.534-2.547z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductTreatment);
export default __webpack_public_path__ + "static/media/icon-product-treatment.1f2c3de4.svg";
export { ForwardRef as ReactComponent };